(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["look-upsell"] && !Shopify.designMode) return;
  try {
    class LookUpsell extends HTMLElement {
    constructor() {
      super();

      // PEGA AS VARIANTES E CRIA UMA ARRAY COM OS IDS, TRANSFORMANDO EM NUMBER
      this.variantIds = this.dataset.products.split(',').map((i) => +i);
      this.removeAttribute('data-products');

      this.checkboxes = this.querySelectorAll('.bundle-checkbox');
      this.totalElement = this.querySelector('.look-upsell__total');

      this.initCheckboxListeners();
      this.initSubmitButton();
      this.updateTotal(); // inicializa o total
    }

    initCheckboxListeners() {
      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          this.updateTotal();
        });
      });
    }

    updateTotal() {
      let totalPrice = 0;

      this.checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          const item = checkbox.closest('.look-upsell__item');
          const bundleProduct = item.querySelector('.bundle-product');
          const price = parseFloat(bundleProduct.dataset.price) / 100;

          totalPrice += price;
        }
      });

      this.totalElement.textContent = totalPrice.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    }

    initSubmitButton() {
      const buttons = [].slice.call(this.querySelectorAll('[add-look-upsell]'));
      console.log(buttons)
      buttons.forEach((btn) => {
        btn.addEventListener('click', this.addVariantsToCart.bind(this));
      });
    }

    addVariantsToCart(event) {
      event.preventDefault();

      const selectedCheckboxes = this.querySelectorAll('.bundle-checkbox:checked');

      const data = Array.from(selectedCheckboxes).map((checkbox) => {
        const item = checkbox.closest('.look-upsell__item');
        const bundleProduct = item.querySelector('.bundle-product');

        return {
          id: +bundleProduct.dataset.variantId,
          quantity: 1,
        };
      });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: data,
        }),
      })
        .then((response) => {
          return window.updateCart();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }

  customElements.define('look-upsell', LookUpsell)
  } catch(e) { console.error(e); }
})();

})();
